import { render } from "./AppSubmenu.vue?vue&type=template&id=008ef8ac&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import "./AppSubmenu.vue?vue&type=style&index=0&id=008ef8ac&lang=scss&scoped=true"

import exportComponent from "/var/www/gl_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008ef8ac"]])

export default __exports__